/**
 * Vector's pixel (loaded by Common Room Signals) throws this when it cannot
 * mint a visitor ID. That is expected for bots, Synthetics, and non-US IPs;
 * we still want Common Room, but not this third-party throw in Error Tracking.
 */
const VECTOR_VISITOR_ID_ERROR_MESSAGE = "No visitor ID available. Load may have failed.";
const VECTOR_PIXEL_STACK_FRAGMENT = "cdn.vector.co/pixel.js";

export function shouldSendRumEvent(event: {
  type: string;
  error?: { message?: string; stack?: string };
}): boolean {
  if (event.type !== "error") return true;
  if (event.error?.message !== VECTOR_VISITOR_ID_ERROR_MESSAGE) return true;
  const stack = event.error.stack;
  if (stack && !stack.includes(VECTOR_PIXEL_STACK_FRAGMENT)) return true;
  return false;
}
